import { createFeatureSelector, createSelector } from '@ngrx/store';
import { IAuthTable } from '../auth.interfaces';
import { authAdapter } from './searcher-auth.reducer';

const {
    selectEntities: _selectSearcherAuthEntities,
  } = authAdapter.getSelectors();

const selectSearcherAuthSelector = createFeatureSelector<IAuthTable>('searcherAuth');

export const selectDefaultSearcherAuthEntity = id => createSelector(
    selectSearcherAuthEntities,
    entities => entities[id]
);

export const selectSearcherAuthEntities = createSelector(
    selectSearcherAuthSelector,
    _selectSearcherAuthEntities
  );
